import React from "react";
import { Button, ListGroup } from "react-bootstrap";
import { FiEye, FiPlus } from "react-icons/fi";
import { TEMPLATE_PREVIEW_LABEL } from "@core/reports/components/TemplateRowPreviewButton";

type Props = {
    title: string;
    sublabel?: string;
    onAdd: () => void;
    addTitle?: string;
    addTestId?: string;
    onPreview?: () => void;
};

const AssignAvailableRow: React.FC<Props> = ({
    title,
    sublabel,
    onAdd,
    addTitle = "Add",
    addTestId,
    onPreview,
}) => (
    <ListGroup.Item className="d-flex align-items-start justify-content-between gap-2">
        <div className="min-w-0 flex-grow-1">
            <div className="fw-semibold">{title}</div>
            {sublabel ? <div className="text-muted small">{sublabel}</div> : null}
        </div>
        <div className="d-flex align-items-start gap-1 flex-shrink-0">
            {onPreview ? (
                <Button
                    type="button"
                    size="sm"
                    variant="outline-secondary"
                    className="assign-icon-btn"
                    onClick={onPreview}
                    title={TEMPLATE_PREVIEW_LABEL}
                    aria-label={TEMPLATE_PREVIEW_LABEL}
                >
                    <FiEye aria-hidden />
                </Button>
            ) : null}
            <Button
                type="button"
                size="sm"
                variant="outline-primary"
                className="assign-icon-btn"
                onClick={onAdd}
                title={addTitle}
                data-testid={addTestId}
            >
                <FiPlus />
            </Button>
        </div>
    </ListGroup.Item>
);

export default AssignAvailableRow;
